import { FadvCommonModule, FadvBadgeDirective, FadvPrefixDirective, FadvSplitButtonDirective, FadvSuffixDirective, FadvSummaryIconDirective, FadvIconLibraryService, FadvComponentsAnalyticsService } from '@fa-switch-sharedservices/ng-elements/common';
export * from '@fa-switch-sharedservices/ng-elements/common';
import { FadvAutocompleteModule, FadvAutocompleteComponent } from '@fa-switch-sharedservices/ng-elements/fadv-autocomplete';
export * from '@fa-switch-sharedservices/ng-elements/fadv-autocomplete';
import { FadvAccordionModule, FadvAccordionComponent, FadvAccordionPanelComponent, FadvAccordionPanelContentComponent, FadvAccordionSummaryActionsDirective, FadvAccordionSummaryComponent } from '@fa-switch-sharedservices/ng-elements/fadv-accordion';
export * from '@fa-switch-sharedservices/ng-elements/fadv-accordion';
import { FadvAlertModule, FadvAlertComponent, FadvAlertIconDirective } from '@fa-switch-sharedservices/ng-elements/fadv-alert';
export * from '@fa-switch-sharedservices/ng-elements/fadv-alert';
import { FadvAlternateAlertModule, FadvAlternateAlertComponent } from '@fa-switch-sharedservices/ng-elements/fadv-alternate-alert';
export * from '@fa-switch-sharedservices/ng-elements/fadv-alternate-alert';
import { FadvApplicationModule, FadvApplicationComponent, FadvContentComponent, FadvFooterComponent, FadvFooterItemComponent, FadvHeaderComponent } from '@fa-switch-sharedservices/ng-elements/fadv-application';
export * from '@fa-switch-sharedservices/ng-elements/fadv-application';
import { FadvAvatarModule, FadvAvatarComponent, FadvAvatarIconDirective } from '@fa-switch-sharedservices/ng-elements/fadv-avatar';
export * from '@fa-switch-sharedservices/ng-elements/fadv-avatar';
import { FadvAvatarGroupModule, FadvAvatarGroupComponent } from '@fa-switch-sharedservices/ng-elements/fadv-avatar-group';
export * from '@fa-switch-sharedservices/ng-elements/fadv-avatar-group';
import { FadvBadgeModule, FadvBadgeComponent } from '@fa-switch-sharedservices/ng-elements/fadv-badge';
export * from '@fa-switch-sharedservices/ng-elements/fadv-badge';
import { FadvBoxModule, FadvBoxComponent } from '@fa-switch-sharedservices/ng-elements/fadv-box';
export * from '@fa-switch-sharedservices/ng-elements/fadv-box';
import { FadvBreadcrumbModule, FadvBreadcrumbComponent, FadvBreadcrumbItemComponent } from '@fa-switch-sharedservices/ng-elements/fadv-breadcrumb';
export * from '@fa-switch-sharedservices/ng-elements/fadv-breadcrumb';
import { FadvButtonModule, FadvButtonCaretDirective, FadvButtonComponent } from '@fa-switch-sharedservices/ng-elements/fadv-button';
export * from '@fa-switch-sharedservices/ng-elements/fadv-button';
import { FadvButtonGridModule, FadvButtonGridComponent } from '@fa-switch-sharedservices/ng-elements/fadv-button-grid';
export * from '@fa-switch-sharedservices/ng-elements/fadv-button-grid';
import { FadvButtonGroupModule, FadvButtonGroupComponent } from '@fa-switch-sharedservices/ng-elements/fadv-button-group';
export * from '@fa-switch-sharedservices/ng-elements/fadv-button-group';
import { FadvCalendarModule, FadvCalendarComponent } from '@fa-switch-sharedservices/ng-elements/fadv-calendar';
export * from '@fa-switch-sharedservices/ng-elements/fadv-calendar';
import { FadvCardModule, FadvCardBodyComponent, FadvCardButtonDirective, FadvCardComponent, FadvCardHeaderComponent, FadvCardIconDirective, FadvCardImageDirective } from '@fa-switch-sharedservices/ng-elements/fadv-card';
export * from '@fa-switch-sharedservices/ng-elements/fadv-card';
import { FadvCarouselModule, FadvCarouselComponent, FadvCarouselSlideComponent } from '@fa-switch-sharedservices/ng-elements/fadv-carousel';
export * from '@fa-switch-sharedservices/ng-elements/fadv-carousel';
import { FadvCheckboxModule, FadvCheckboxComponent, FadvCheckboxLinkDirective } from '@fa-switch-sharedservices/ng-elements/fadv-checkbox';
export * from '@fa-switch-sharedservices/ng-elements/fadv-checkbox';
import { FadvCheckboxCardModule, FadvCheckboxCardBadgeDirective, FadvCheckboxCardComponent, FadvCheckboxCardHeadingDirective, FadvCheckboxCardSubHeadingDirective } from '@fa-switch-sharedservices/ng-elements/fadv-checkbox-card';
export * from '@fa-switch-sharedservices/ng-elements/fadv-checkbox-card';
import { FadvCreditCardModule, FadvCreditCardComponent } from '@fa-switch-sharedservices/ng-elements/fadv-credit-card';
export * from '@fa-switch-sharedservices/ng-elements/fadv-credit-card';
import { FadvDashboardModule, FadvDashboardComponent } from '@fa-switch-sharedservices/ng-elements/fadv-dashboard';
export * from '@fa-switch-sharedservices/ng-elements/fadv-dashboard';
import { FadvDatePickerModule, FadvDatePickerComponent, FadvDateRangePickerComponent } from '@fa-switch-sharedservices/ng-elements/fadv-date-picker';
export * from '@fa-switch-sharedservices/ng-elements/fadv-date-picker';
import { FadvDetailsModule, FadvDetailsComponent } from '@fa-switch-sharedservices/ng-elements/fadv-details';
export * from '@fa-switch-sharedservices/ng-elements/fadv-details';
import { FadvDividerModule, FadvDividerDirective } from '@fa-switch-sharedservices/ng-elements/fadv-divider';
export * from '@fa-switch-sharedservices/ng-elements/fadv-divider';
import { FadvDocumentViewerModule, FadvDocumentViewerComponent } from '@fa-switch-sharedservices/ng-elements/fadv-document-viewer';
export * from '@fa-switch-sharedservices/ng-elements/fadv-document-viewer';
import { FadvDrawerModule, FadvApplicationDrawerDirective, FadvDrawerComponent, FadvDrawerEndComponent, FadvDrawerSecondaryMenuDirective, FadvDrawerStartComponent } from '@fa-switch-sharedservices/ng-elements/fadv-drawer';
export * from '@fa-switch-sharedservices/ng-elements/fadv-drawer';
import { FadvDropdownModule, FadvDropdownComponent, FadvDropdownTriggerDirective } from '@fa-switch-sharedservices/ng-elements/fadv-dropdown';
export * from '@fa-switch-sharedservices/ng-elements/fadv-dropdown';
import { FadvExpansionModule, FadvExpansionComponent, FadvExpansionPanelDirective } from '@fa-switch-sharedservices/ng-elements/fadv-expansion';
export * from '@fa-switch-sharedservices/ng-elements/fadv-expansion';
import { FadvFilterModule, FadvFilterComponent } from '@fa-switch-sharedservices/ng-elements/fadv-filter';
export * from '@fa-switch-sharedservices/ng-elements/fadv-filter';
import { FadvGridModule, FadvGridColComponent, FadvGridComponent, FadvGridRowComponent } from '@fa-switch-sharedservices/ng-elements/fadv-grid';
export * from '@fa-switch-sharedservices/ng-elements/fadv-grid';
import { FadvHighlightModule, FadvHighlightComponent } from '@fa-switch-sharedservices/ng-elements/fadv-highlight';
export * from '@fa-switch-sharedservices/ng-elements/fadv-highlight';
import { FadvIconModule, FadvDocumentIconDirective, FadvIconComponent } from '@fa-switch-sharedservices/ng-elements/fadv-icon';
export * from '@fa-switch-sharedservices/ng-elements/fadv-icon';
import { FadvImageComparerModule, FadvImageComparerAfterDirective, FadvImageComparerBeforeDirective, FadvImageComparerComponent } from '@fa-switch-sharedservices/ng-elements/fadv-image-comparer';
export * from '@fa-switch-sharedservices/ng-elements/fadv-image-comparer';
import { FadvInlineAlertModule, FadvInlineAlertComponent } from '@fa-switch-sharedservices/ng-elements/fadv-inline-alert';
export * from '@fa-switch-sharedservices/ng-elements/fadv-inline-alert';
import { FadvInputModule, FadvInputAfterDirective, FadvInputBeforeDirective, FadvInputComponent } from '@fa-switch-sharedservices/ng-elements/fadv-input';
export * from '@fa-switch-sharedservices/ng-elements/fadv-input';
import { FadvLayoutModule, FadvLayoutComponent, FadvLayoutMainComponent, FadvLayoutSectionComponent, FadvScrollerComponent } from '@fa-switch-sharedservices/ng-elements/fadv-layout';
export * from '@fa-switch-sharedservices/ng-elements/fadv-layout';
import { FadvLoaderModule, FadvLoaderComponent } from '@fa-switch-sharedservices/ng-elements/fadv-loader';
export * from '@fa-switch-sharedservices/ng-elements/fadv-loader';
import { FadvMenuModule, FadvMenuCategoryComponent, FadvMenuComponent, FadvMenuItemCheckboxComponent, FadvMenuItemComponent, FadvMenuItemLinkComponent, FadvMenuLabelComponent, FadvSubmenuDirective } from '@fa-switch-sharedservices/ng-elements/fadv-menu';
export * from '@fa-switch-sharedservices/ng-elements/fadv-menu';
import { FadvMessageBoxModule, FadvMessageBoxComponent, FadvMessageBoxHeaderComponent, FadvMessageComponent, FadvMessageInputComponent } from '@fa-switch-sharedservices/ng-elements/fadv-message-box';
export * from '@fa-switch-sharedservices/ng-elements/fadv-message-box';
import { FadvModalModule, FadvModalAlertDirective, FadvModalBodyComponent, FadvModalButtonDirective, FadvModalComponent, FadvModalDrawerComponent, FadvModalHeaderDirective, FadvModalMobileComponent } from '@fa-switch-sharedservices/ng-elements/fadv-modal';
export * from '@fa-switch-sharedservices/ng-elements/fadv-modal';
import { FadvNavigationModule, FadvNavigationComponent, FadvNavigationEndComponent, FadvNavigationStartComponent } from '@fa-switch-sharedservices/ng-elements/fadv-navigation';
export * from '@fa-switch-sharedservices/ng-elements/fadv-navigation';
import { FadvOneTimePinModule, FadvOneTimePinComponent } from '@fa-switch-sharedservices/ng-elements/fadv-one-time-pin';
export * from '@fa-switch-sharedservices/ng-elements/fadv-one-time-pin';
import { FadvPaginationModule, FadvPaginationComponent } from '@fa-switch-sharedservices/ng-elements/fadv-pagination';
export * from '@fa-switch-sharedservices/ng-elements/fadv-pagination';
import { FadvPasswordValidatorModule, FadvPasswordValidatorComponent, FadvPasswordValidatorRuleComponent } from '@fa-switch-sharedservices/ng-elements/fadv-password-validator';
export * from '@fa-switch-sharedservices/ng-elements/fadv-password-validator';
import { FadvProfileCardModule, FadvProfileCardAvatarDirective, FadvProfileCardComponent, FadvProfileCardItemComponent } from '@fa-switch-sharedservices/ng-elements/fadv-profile-card';
export * from '@fa-switch-sharedservices/ng-elements/fadv-profile-card';
import { FadvProgressBarModule, FadvProgressBarComponent } from '@fa-switch-sharedservices/ng-elements/fadv-progress-bar';
export * from '@fa-switch-sharedservices/ng-elements/fadv-progress-bar';
import { FadvProgressCardModule, FadvProgressCardComponent } from '@fa-switch-sharedservices/ng-elements/fadv-progress-card';
export * from '@fa-switch-sharedservices/ng-elements/fadv-progress-card';
import { FadvProgressDotsModule, FadvProgressDotComponent, FadvProgressDotsComponent } from '@fa-switch-sharedservices/ng-elements/fadv-progress-dots';
export * from '@fa-switch-sharedservices/ng-elements/fadv-progress-dots';
import { FadvProgressRingModule, FadvProgressRingComponent } from '@fa-switch-sharedservices/ng-elements/fadv-progress-ring';
export * from '@fa-switch-sharedservices/ng-elements/fadv-progress-ring';
import { FadvRadioModule, FadvRadioComponent } from '@fa-switch-sharedservices/ng-elements/fadv-radio';
export * from '@fa-switch-sharedservices/ng-elements/fadv-radio';
import { FadvRadioButtonComponent } from '@fa-switch-sharedservices/ng-elements/fadv-radio-button';
export * from '@fa-switch-sharedservices/ng-elements/fadv-radio-button';
import { FadvRadioCardModule, FadvRadioCardComponent, FadvRadioCardIconDirective } from '@fa-switch-sharedservices/ng-elements/fadv-radio-card';
export * from '@fa-switch-sharedservices/ng-elements/fadv-radio-card';
import { FadvRadioGroupModule, FadvRadioGroupComponent } from '@fa-switch-sharedservices/ng-elements/fadv-radio-group';
export * from '@fa-switch-sharedservices/ng-elements/fadv-radio-group';
import { FadvRangeModule, FadvRangeComponent } from '@fa-switch-sharedservices/ng-elements/fadv-range';
export * from '@fa-switch-sharedservices/ng-elements/fadv-range';
import { FadvRatingModule, FadvRatingComponent } from '@fa-switch-sharedservices/ng-elements/fadv-rating';
export * from '@fa-switch-sharedservices/ng-elements/fadv-rating';
import { FadvSearchModule, FadvNestedSearchDirective, FadvSearchComponent } from '@fa-switch-sharedservices/ng-elements/fadv-search';
export * from '@fa-switch-sharedservices/ng-elements/fadv-search';
import { FadvSelectModule, FadvSelectComponent } from '@fa-switch-sharedservices/ng-elements/fadv-select';
export * from '@fa-switch-sharedservices/ng-elements/fadv-select';
import { FadvSignatureModule, FadvSignatureComponent } from '@fa-switch-sharedservices/ng-elements/fadv-signature';
export * from '@fa-switch-sharedservices/ng-elements/fadv-signature';
import { FadvSkeletonModule, FadvSkeletonComponent } from '@fa-switch-sharedservices/ng-elements/fadv-skeleton';
export * from '@fa-switch-sharedservices/ng-elements/fadv-skeleton';
import { FadvSpinnerModule, FadvSpinnerComponent } from '@fa-switch-sharedservices/ng-elements/fadv-spinner';
export * from '@fa-switch-sharedservices/ng-elements/fadv-spinner';
import { FadvStepperModule, FadvStepComponent, FadvStepPanelComponent, FadvStepperComponent } from '@fa-switch-sharedservices/ng-elements/fadv-stepper';
export * from '@fa-switch-sharedservices/ng-elements/fadv-stepper';
import { FadvSwitchModule, FadvSwitchComponent, FadvSwitchOffIconDirective, FadvSwitchOnDirective } from '@fa-switch-sharedservices/ng-elements/fadv-switch';
export * from '@fa-switch-sharedservices/ng-elements/fadv-switch';
import { FadvTabsModule, FadvTabComponent, FadvTabGroupComponent, FadvTabPanelComponent } from '@fa-switch-sharedservices/ng-elements/fadv-tab-group';
export * from '@fa-switch-sharedservices/ng-elements/fadv-tab-group';
import { FadvTableModule, FadvTableColumnDirective, FadvTableComponent, FadvTableFooterComponent, FadvTableHeadColumnDirective, FadvTableHeaderComponent, FadvTableHeadRowDirective, FadvTableRowDirective, FadvTableRowExpansionDirective } from '@fa-switch-sharedservices/ng-elements/fadv-table';
export * from '@fa-switch-sharedservices/ng-elements/fadv-table';
import { FadvTagModule, FadvTagComponent } from '@fa-switch-sharedservices/ng-elements/fadv-tag';
export * from '@fa-switch-sharedservices/ng-elements/fadv-tag';
import { FadvTextareaModule, FadvTextareaComponent } from '@fa-switch-sharedservices/ng-elements/fadv-textarea';
export * from '@fa-switch-sharedservices/ng-elements/fadv-textarea';
import { FadvTimerModule, FadvTimerComponent } from '@fa-switch-sharedservices/ng-elements/fadv-timer';
export * from '@fa-switch-sharedservices/ng-elements/fadv-timer';
import { FadvToastModule, FadvToastComponent, FadvToastContentDirective, FadvToastHeaderDirective } from '@fa-switch-sharedservices/ng-elements/fadv-toast';
export * from '@fa-switch-sharedservices/ng-elements/fadv-toast';
import { FadvToastOutletModule, FadvToastOutletComponent } from '@fa-switch-sharedservices/ng-elements/fadv-toast-outlet';
export * from '@fa-switch-sharedservices/ng-elements/fadv-toast-outlet';
import { FadvTooltipModule, FadvTooltipComponent, FadvTooltipContentComponent } from '@fa-switch-sharedservices/ng-elements/fadv-tooltip';
export * from '@fa-switch-sharedservices/ng-elements/fadv-tooltip';
import { FadvTypographyModule, FadvTypographyComponent } from '@fa-switch-sharedservices/ng-elements/fadv-typography';
export * from '@fa-switch-sharedservices/ng-elements/fadv-typography';
import { FadvUploaderModule, FadvUploaderBarComponent, FadvUploaderComponent } from '@fa-switch-sharedservices/ng-elements/fadv-uploader';
export * from '@fa-switch-sharedservices/ng-elements/fadv-uploader';
import { FadvVisuallyHiddenModule, FadvVisuallyHiddenComponent } from '@fa-switch-sharedservices/ng-elements/fadv-visually-hidden';
export * from '@fa-switch-sharedservices/ng-elements/fadv-visually-hidden';
import * as i0 from '@angular/core';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

class FadvComponentsModule {
    constructor() {
        console.warn('The FadvComponentsModule should not be used in a production application. Please import required component modules directly.');
    }
}
FadvComponentsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvComponentsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvComponentsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvComponentsModule, imports: [FadvCommonModule,
        FadvAutocompleteModule,
        FadvAccordionModule,
        FadvAlertModule,
        FadvAlternateAlertModule,
        FadvApplicationModule,
        FadvAvatarModule,
        FadvAvatarGroupModule,
        FadvBadgeModule,
        FadvBoxModule,
        FadvButtonGridModule,
        FadvButtonGroupModule,
        FadvButtonModule,
        FadvCalendarModule,
        FadvCardModule,
        FadvCarouselModule,
        FadvCheckboxCardModule,
        FadvCheckboxModule,
        FadvCreditCardModule,
        FadvDashboardModule,
        FadvDatePickerModule,
        FadvDetailsModule,
        FadvDividerModule,
        FadvDocumentViewerModule,
        FadvDrawerModule,
        FadvDropdownModule,
        FadvExpansionModule,
        FadvFilterModule,
        FadvGridModule,
        FadvHighlightModule,
        FadvIconModule,
        FadvImageComparerModule,
        FadvInlineAlertModule,
        FadvInputModule,
        FadvLayoutModule,
        FadvLoaderModule,
        FadvMenuModule,
        FadvMessageBoxModule,
        FadvModalModule,
        FadvNavigationModule,
        FadvOneTimePinModule,
        FadvPaginationModule,
        FadvPasswordValidatorModule,
        FadvProfileCardModule,
        FadvProgressBarModule,
        FadvProgressCardModule,
        FadvProgressDotsModule,
        FadvProgressRingModule,
        FadvRadioCardModule,
        FadvRadioGroupModule,
        FadvRadioModule,
        FadvRangeModule,
        FadvRatingModule,
        FadvSearchModule,
        FadvSelectModule,
        FadvSignatureModule,
        FadvSkeletonModule,
        FadvSpinnerModule,
        FadvStepperModule,
        FadvSwitchModule,
        FadvTableModule,
        FadvTabsModule,
        FadvTagModule,
        FadvTextareaModule,
        FadvTimerModule,
        FadvToastModule,
        FadvToastOutletModule,
        FadvTooltipModule,
        FadvTypographyModule,
        FadvUploaderModule,
        FadvVisuallyHiddenModule,
        FadvBreadcrumbModule], exports: [FadvAutocompleteComponent,
        FadvAccordionComponent,
        FadvAccordionPanelComponent,
        FadvAccordionPanelContentComponent,
        FadvAccordionSummaryActionsDirective,
        FadvAccordionSummaryComponent,
        FadvAlertComponent,
        FadvAlertIconDirective,
        FadvAlternateAlertComponent,
        FadvApplicationComponent,
        FadvApplicationDrawerDirective,
        FadvAvatarComponent,
        FadvAvatarIconDirective,
        FadvAvatarGroupComponent,
        FadvBadgeComponent,
        FadvBoxComponent,
        FadvBreadcrumbComponent,
        FadvBreadcrumbItemComponent,
        FadvButtonCaretDirective,
        FadvButtonComponent,
        FadvButtonGridComponent,
        FadvButtonGroupComponent,
        FadvCalendarComponent,
        FadvCardBodyComponent,
        FadvCardButtonDirective,
        FadvCardComponent,
        FadvCardHeaderComponent,
        FadvCardIconDirective,
        FadvCardImageDirective,
        FadvCarouselComponent,
        FadvCarouselSlideComponent,
        FadvCheckboxCardBadgeDirective,
        FadvCheckboxCardComponent,
        FadvCheckboxCardHeadingDirective,
        FadvCheckboxCardSubHeadingDirective,
        FadvCheckboxComponent,
        FadvCheckboxLinkDirective,
        FadvCommonModule,
        FadvContentComponent,
        FadvCreditCardComponent,
        FadvDashboardComponent,
        FadvDatePickerComponent,
        FadvDateRangePickerComponent,
        FadvDetailsComponent,
        FadvDividerDirective,
        FadvDocumentIconDirective,
        FadvDocumentViewerComponent,
        FadvDrawerComponent,
        FadvDrawerEndComponent,
        FadvDrawerSecondaryMenuDirective,
        FadvDrawerStartComponent,
        FadvDropdownComponent,
        FadvDropdownTriggerDirective,
        FadvExpansionComponent,
        FadvExpansionPanelDirective,
        FadvFilterComponent,
        FadvFooterComponent,
        FadvFooterItemComponent,
        FadvGridColComponent,
        FadvGridComponent,
        FadvGridRowComponent,
        FadvHeaderComponent,
        FadvHighlightComponent,
        FadvIconComponent,
        FadvImageComparerAfterDirective,
        FadvImageComparerBeforeDirective,
        FadvImageComparerComponent,
        FadvInlineAlertComponent,
        FadvInputAfterDirective,
        FadvInputBeforeDirective,
        FadvInputComponent,
        FadvLayoutComponent,
        FadvLayoutMainComponent,
        FadvLayoutSectionComponent,
        FadvLoaderComponent,
        FadvMenuCategoryComponent,
        FadvMenuComponent,
        FadvMenuItemCheckboxComponent,
        FadvMenuItemComponent,
        FadvMenuItemLinkComponent,
        FadvMenuLabelComponent,
        FadvMessageBoxComponent,
        FadvMessageBoxHeaderComponent,
        FadvMessageComponent,
        FadvMessageInputComponent,
        FadvModalAlertDirective,
        FadvModalBodyComponent,
        FadvModalButtonDirective,
        FadvModalComponent,
        FadvModalDrawerComponent,
        FadvModalHeaderDirective,
        FadvModalMobileComponent,
        FadvNavigationComponent,
        FadvNavigationEndComponent,
        FadvNavigationStartComponent,
        FadvNestedSearchDirective,
        FadvOneTimePinComponent,
        FadvPaginationComponent,
        FadvPasswordValidatorComponent,
        FadvPasswordValidatorRuleComponent,
        FadvBadgeDirective,
        FadvPrefixDirective,
        FadvProfileCardAvatarDirective,
        FadvProfileCardComponent,
        FadvProfileCardItemComponent,
        FadvProgressBarComponent,
        FadvProgressCardComponent,
        FadvProgressDotComponent,
        FadvProgressDotsComponent,
        FadvProgressRingComponent,
        FadvRadioButtonComponent,
        FadvRadioCardComponent,
        FadvRadioCardIconDirective,
        FadvRadioComponent,
        FadvRadioGroupComponent,
        FadvRangeComponent,
        FadvRatingComponent,
        FadvScrollerComponent,
        FadvSearchComponent,
        FadvSelectComponent,
        FadvSignatureComponent,
        FadvSkeletonComponent,
        FadvSpinnerComponent,
        FadvSplitButtonDirective,
        FadvStepComponent,
        FadvStepPanelComponent,
        FadvStepperComponent,
        FadvSubmenuDirective,
        FadvSuffixDirective,
        FadvSummaryIconDirective,
        FadvSwitchComponent,
        FadvSwitchOffIconDirective,
        FadvSwitchOnDirective,
        FadvTabComponent,
        FadvTabGroupComponent,
        FadvTableColumnDirective,
        FadvTableComponent,
        FadvTableFooterComponent,
        FadvTableHeadColumnDirective,
        FadvTableHeaderComponent,
        FadvTableHeadRowDirective,
        FadvTableRowDirective,
        FadvTableRowExpansionDirective,
        FadvTabPanelComponent,
        FadvTagComponent,
        FadvTextareaComponent,
        FadvTimerComponent,
        FadvToastComponent,
        FadvToastContentDirective,
        FadvToastHeaderDirective,
        FadvToastOutletComponent,
        FadvTooltipComponent,
        FadvTooltipContentComponent,
        FadvTypographyComponent,
        FadvUploaderBarComponent,
        FadvUploaderComponent,
        FadvVisuallyHiddenComponent] });
FadvComponentsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvComponentsModule, providers: [FadvIconLibraryService, FadvComponentsAnalyticsService], imports: [FadvCommonModule,
        FadvAutocompleteModule,
        FadvAccordionModule,
        FadvAlertModule,
        FadvAlternateAlertModule,
        FadvApplicationModule,
        FadvAvatarModule,
        FadvAvatarGroupModule,
        FadvBadgeModule,
        FadvBoxModule,
        FadvButtonGridModule,
        FadvButtonGroupModule,
        FadvButtonModule,
        FadvCalendarModule,
        FadvCardModule,
        FadvCarouselModule,
        FadvCheckboxCardModule,
        FadvCheckboxModule,
        FadvCreditCardModule,
        FadvDashboardModule,
        FadvDatePickerModule,
        FadvDetailsModule,
        FadvDividerModule,
        FadvDocumentViewerModule,
        FadvDrawerModule,
        FadvDropdownModule,
        FadvExpansionModule,
        FadvFilterModule,
        FadvGridModule,
        FadvHighlightModule,
        FadvIconModule,
        FadvImageComparerModule,
        FadvInlineAlertModule,
        FadvInputModule,
        FadvLayoutModule,
        FadvLoaderModule,
        FadvMenuModule,
        FadvMessageBoxModule,
        FadvModalModule,
        FadvNavigationModule,
        FadvOneTimePinModule,
        FadvPaginationModule,
        FadvPasswordValidatorModule,
        FadvProfileCardModule,
        FadvProgressBarModule,
        FadvProgressCardModule,
        FadvProgressDotsModule,
        FadvProgressRingModule,
        FadvRadioCardModule,
        FadvRadioGroupModule,
        FadvRadioModule,
        FadvRangeModule,
        FadvRatingModule,
        FadvSearchModule,
        FadvSelectModule,
        FadvSignatureModule,
        FadvSkeletonModule,
        FadvSpinnerModule,
        FadvStepperModule,
        FadvSwitchModule,
        FadvTableModule,
        FadvTabsModule,
        FadvTagModule,
        FadvTextareaModule,
        FadvTimerModule,
        FadvToastModule,
        FadvToastOutletModule,
        FadvTooltipModule,
        FadvTypographyModule,
        FadvUploaderModule,
        FadvVisuallyHiddenModule,
        FadvBreadcrumbModule, FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvComponentsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FadvCommonModule,
                        FadvAutocompleteModule,
                        FadvAccordionModule,
                        FadvAlertModule,
                        FadvAlternateAlertModule,
                        FadvApplicationModule,
                        FadvAvatarModule,
                        FadvAvatarGroupModule,
                        FadvBadgeModule,
                        FadvBoxModule,
                        FadvButtonGridModule,
                        FadvButtonGroupModule,
                        FadvButtonModule,
                        FadvCalendarModule,
                        FadvCardModule,
                        FadvCarouselModule,
                        FadvCheckboxCardModule,
                        FadvCheckboxModule,
                        FadvCreditCardModule,
                        FadvDashboardModule,
                        FadvDatePickerModule,
                        FadvDetailsModule,
                        FadvDividerModule,
                        FadvDocumentViewerModule,
                        FadvDrawerModule,
                        FadvDropdownModule,
                        FadvExpansionModule,
                        FadvFilterModule,
                        FadvGridModule,
                        FadvHighlightModule,
                        FadvIconModule,
                        FadvImageComparerModule,
                        FadvInlineAlertModule,
                        FadvInputModule,
                        FadvLayoutModule,
                        FadvLoaderModule,
                        FadvMenuModule,
                        FadvMessageBoxModule,
                        FadvModalModule,
                        FadvNavigationModule,
                        FadvOneTimePinModule,
                        FadvPaginationModule,
                        FadvPasswordValidatorModule,
                        FadvProfileCardModule,
                        FadvProgressBarModule,
                        FadvProgressCardModule,
                        FadvProgressDotsModule,
                        FadvProgressRingModule,
                        FadvRadioCardModule,
                        FadvRadioGroupModule,
                        FadvRadioModule,
                        FadvRangeModule,
                        FadvRatingModule,
                        FadvSearchModule,
                        FadvSelectModule,
                        FadvSignatureModule,
                        FadvSkeletonModule,
                        FadvSpinnerModule,
                        FadvStepperModule,
                        FadvSwitchModule,
                        FadvTableModule,
                        FadvTabsModule,
                        FadvTagModule,
                        FadvTextareaModule,
                        FadvTimerModule,
                        FadvToastModule,
                        FadvToastOutletModule,
                        FadvTooltipModule,
                        FadvTypographyModule,
                        FadvUploaderModule,
                        FadvVisuallyHiddenModule,
                        FadvBreadcrumbModule,
                    ],
                    exports: [
                        FadvAutocompleteComponent,
                        FadvAccordionComponent,
                        FadvAccordionPanelComponent,
                        FadvAccordionPanelContentComponent,
                        FadvAccordionSummaryActionsDirective,
                        FadvAccordionSummaryComponent,
                        FadvAlertComponent,
                        FadvAlertIconDirective,
                        FadvAlternateAlertComponent,
                        FadvApplicationComponent,
                        FadvApplicationDrawerDirective,
                        FadvAvatarComponent,
                        FadvAvatarIconDirective,
                        FadvAvatarGroupComponent,
                        FadvBadgeComponent,
                        FadvBoxComponent,
                        FadvBreadcrumbComponent,
                        FadvBreadcrumbItemComponent,
                        FadvButtonCaretDirective,
                        FadvButtonComponent,
                        FadvButtonGridComponent,
                        FadvButtonGroupComponent,
                        FadvCalendarComponent,
                        FadvCardBodyComponent,
                        FadvCardButtonDirective,
                        FadvCardComponent,
                        FadvCardHeaderComponent,
                        FadvCardIconDirective,
                        FadvCardImageDirective,
                        FadvCarouselComponent,
                        FadvCarouselSlideComponent,
                        FadvCheckboxCardBadgeDirective,
                        FadvCheckboxCardComponent,
                        FadvCheckboxCardHeadingDirective,
                        FadvCheckboxCardSubHeadingDirective,
                        FadvCheckboxComponent,
                        FadvCheckboxLinkDirective,
                        FadvCommonModule,
                        FadvContentComponent,
                        FadvCreditCardComponent,
                        FadvDashboardComponent,
                        FadvDatePickerComponent,
                        FadvDateRangePickerComponent,
                        FadvDetailsComponent,
                        FadvDividerDirective,
                        FadvDocumentIconDirective,
                        FadvDocumentViewerComponent,
                        FadvDrawerComponent,
                        FadvDrawerEndComponent,
                        FadvDrawerSecondaryMenuDirective,
                        FadvDrawerStartComponent,
                        FadvDropdownComponent,
                        FadvDropdownTriggerDirective,
                        FadvExpansionComponent,
                        FadvExpansionPanelDirective,
                        FadvFilterComponent,
                        FadvFooterComponent,
                        FadvFooterItemComponent,
                        FadvGridColComponent,
                        FadvGridComponent,
                        FadvGridRowComponent,
                        FadvHeaderComponent,
                        FadvHighlightComponent,
                        FadvIconComponent,
                        FadvImageComparerAfterDirective,
                        FadvImageComparerBeforeDirective,
                        FadvImageComparerComponent,
                        FadvInlineAlertComponent,
                        FadvInputAfterDirective,
                        FadvInputBeforeDirective,
                        FadvInputComponent,
                        FadvLayoutComponent,
                        FadvLayoutMainComponent,
                        FadvLayoutSectionComponent,
                        FadvLoaderComponent,
                        FadvMenuCategoryComponent,
                        FadvMenuComponent,
                        FadvMenuItemCheckboxComponent,
                        FadvMenuItemComponent,
                        FadvMenuItemLinkComponent,
                        FadvMenuLabelComponent,
                        FadvMessageBoxComponent,
                        FadvMessageBoxHeaderComponent,
                        FadvMessageComponent,
                        FadvMessageInputComponent,
                        FadvModalAlertDirective,
                        FadvModalBodyComponent,
                        FadvModalButtonDirective,
                        FadvModalComponent,
                        FadvModalDrawerComponent,
                        FadvModalHeaderDirective,
                        FadvModalMobileComponent,
                        FadvNavigationComponent,
                        FadvNavigationEndComponent,
                        FadvNavigationStartComponent,
                        FadvNestedSearchDirective,
                        FadvOneTimePinComponent,
                        FadvPaginationComponent,
                        FadvPasswordValidatorComponent,
                        FadvPasswordValidatorRuleComponent,
                        FadvBadgeDirective,
                        FadvPrefixDirective,
                        FadvProfileCardAvatarDirective,
                        FadvProfileCardComponent,
                        FadvProfileCardItemComponent,
                        FadvProgressBarComponent,
                        FadvProgressCardComponent,
                        FadvProgressDotComponent,
                        FadvProgressDotsComponent,
                        FadvProgressRingComponent,
                        FadvRadioButtonComponent,
                        FadvRadioCardComponent,
                        FadvRadioCardIconDirective,
                        FadvRadioComponent,
                        FadvRadioGroupComponent,
                        FadvRangeComponent,
                        FadvRatingComponent,
                        FadvScrollerComponent,
                        FadvSearchComponent,
                        FadvSelectComponent,
                        FadvSignatureComponent,
                        FadvSkeletonComponent,
                        FadvSpinnerComponent,
                        FadvSplitButtonDirective,
                        FadvStepComponent,
                        FadvStepPanelComponent,
                        FadvStepperComponent,
                        FadvSubmenuDirective,
                        FadvSuffixDirective,
                        FadvSummaryIconDirective,
                        FadvSwitchComponent,
                        FadvSwitchOffIconDirective,
                        FadvSwitchOnDirective,
                        FadvTabComponent,
                        FadvTabGroupComponent,
                        FadvTableColumnDirective,
                        FadvTableComponent,
                        FadvTableFooterComponent,
                        FadvTableHeadColumnDirective,
                        FadvTableHeaderComponent,
                        FadvTableHeadRowDirective,
                        FadvTableRowDirective,
                        FadvTableRowExpansionDirective,
                        FadvTabPanelComponent,
                        FadvTagComponent,
                        FadvTextareaComponent,
                        FadvTimerComponent,
                        FadvToastComponent,
                        FadvToastContentDirective,
                        FadvToastHeaderDirective,
                        FadvToastOutletComponent,
                        FadvTooltipComponent,
                        FadvTooltipContentComponent,
                        FadvTypographyComponent,
                        FadvUploaderBarComponent,
                        FadvUploaderComponent,
                        FadvVisuallyHiddenComponent,
                    ],
                    providers: [FadvIconLibraryService, FadvComponentsAnalyticsService],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }], ctorParameters: function () { return []; } });

/*
 * Public API Surface of angular-components
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FadvComponentsModule };
